import { isEmpty } from 'lodash'
import { IVehicleInfo } from 'types/vehicleTypes'
import { toUrlSearchParams } from './urlParams'
import { ISearchFilterResult } from 'types/vehicleTypes'

export const buildMMRUrl = (mmrHost: string, vehicleInfo: IVehicleInfo) => {
  let mmrLink = `${mmrHost ?? 'https://mmr.manheim.com'}/?popup=true`

  if (isEmpty(vehicleInfo)) return mmrLink

  mmrLink += `&vin=${vehicleInfo.VIN}`
  const properties = vehicleInfo.Properties.filter((x) => x.ID === 1)

  // Mileage (Odometer)
  let prop = properties.find((p) => p.UIConstantName === 'MILEAGE')?.Description
  if (!isEmpty(prop)) mmrLink += `&mileage=${parseFloat(prop.replace(/,/g, ''))}`

  // Condition Grade
  prop = properties.find((p) => p.UIConstantName === 'DD_CONDITION')?.Description
  if (!isEmpty(prop)) mmrLink += `&condition=${prop}`

  mmrLink += '&country=US'

  return mmrLink
}

export const getVdpUrl = (vehicleInstanceId: number) => `/vehicle/${vehicleInstanceId}`

export const getWatchlistUrl = () => '/watchlist'
export const getCurrentBidsUrl = () => '/currentBids'
export const getSearchUrl = () => '/search'
export const getSaveSearchUrl = () => '/vehicles#savedSearch'

export const getFilterSeachResultUrl = (filterField: string, filterValue: string) => {
  sessionStorage.setItem(
    'QueryFilters',
    JSON.stringify([
      {
        ChildrenFilter: [],
        DBFieldName: filterField,
        FieldId: -1,
        Value: filterValue,
        Value2: '',
        Value3: '',
        Operation: 1,
        VehicleCount: 0,
        QuickSearchOrderNumber: 0,
        Selected: true,
        DynamicFilter: true,
        verified: false
      }
    ])
  )
  const url = `/search?filters=${filterField}@${filterValue}`
  return url
}

export const mergeQueryFilters = (
  existingFilters: ISearchFilterResult[] = [],
  queryFilters: ISearchFilterResult[] = []
): ISearchFilterResult[] => {
  // Ensure existingFilters is an array
  const safeExistingFilters = Array.isArray(existingFilters) ? existingFilters : []

  if (!queryFilters || !Array.isArray(queryFilters) || queryFilters.length === 0) {
    return safeExistingFilters
  }

  const mergedFilters = [...safeExistingFilters]

  queryFilters.forEach((queryFilter) => {
    // Check if this filter already exists in existing filters
    const existingFilter = safeExistingFilters.find(
      (ef) => ef.FieldId === queryFilter.FieldId || ef.DBFieldName === queryFilter.DBFieldName
    )

    if (!existingFilter) {
      mergedFilters.push(queryFilter)
    }
  })

  return mergedFilters
}

export const getAwaitingReportUrl = (
  minDateAwaitingInspection: string,
  maxDateAwaitingInspection: string,
  listOfVin: string
) =>
  `/account#awaitingInspectionReport?${toUrlSearchParams({
    fromDate: minDateAwaitingInspection,
    toDate: maxDateAwaitingInspection,
    vin: listOfVin
  })}`
